export const NflProperties = () => {
  return (
    <div>
      {" "}
      <div
        className=""
        id="prolineModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="contactModalLabel"
      >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body" style={{ height: "100%" }}>
              <div className="row">
                <div className="col-lg-4">
                  <img
                    className="profile-image"
                    src="/images/executioners/proline.jpg"
                    alt="NFL Properties ProLine campaign"
                    style={{ margin: "10px 0" }}
                  />
                </div>
                <div className="col-lg-8">
                  <div className="modal-title-container">
                    <h4 className="modal-title" id="contactModalLabel">
                      NFL Properties
                    </h4>
                  </div>
                  <div className="modal-body-container">
                    <p className="helvetica-nueue">
                      <strong>OBJECTIVE</strong>
                    </p>
                    <p>
                      To convince more than 14,000 retailers of NFL logo
                      clothing that they:{" "}
                    </p>
                    <ol style={{ fontSize: "1.1em" }}>
                      <li>
                        Should carry this new line of authentic “Pro Quality”
                        sports wear.
                      </li>
                      <li>
                        Will be supported in their selling efforts by a massive
                        consumer advertising campaign and in-store promotions
                        from the NFL.
                      </li>
                    </ol>
                    <p className="helvetica-nueue">
                      <strong>RESULTS</strong>
                    </p>
                    <p>
                      Over 8,000 retailers signed on in six months. Within 18
                      months 97% of NFL Properties clothing retailers had at
                      least one item of the Authentic ProLine in their stores.
                      Those who set up ProLine Boutiques reported as much as a
                      23% bump in their overall NFL clothing sales.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-default"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
